module.exports = __webpack_public_path__ + "img/svg-competencia.776ac850.svg";